import styled from 'styled-components';

export const YearEndForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
